import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, Gamepad2, UserRound, Handshake } from 'lucide-react';

const SIDE_TABS_LEFT = [
  { id: 'pagos', label: 'Pagos', icon: Wallet },
  { id: 'aliados', label: 'Aliados', icon: Handshake, badge: 'Próximamente' },
];

const SIDE_TABS_RIGHT = [
  { id: 'juegos', label: 'Juegos', icon: Gamepad2, badge: 'Próximamente' },
  { id: 'perfil', label: 'Perfil', icon: UserRound },
];

function SideTab({ tab, isActive, onChange }) {
  const Icon = tab.icon;
  return (
    <button
      onClick={() => onChange(tab.id)}
      className="relative flex flex-col items-center justify-center gap-0.5 py-2 px-4 min-w-[60px] transition-colors"
      data-testid={`nav-tab-${tab.id}`}
    >
      <div className="relative">
        <Icon className={`w-5 h-5 transition-colors ${isActive ? 'text-[#fbb040]' : 'text-gray-400'}`} />
        {tab.badge && (
          <span className="absolute -top-1.5 -right-3 bg-red-500 text-white text-[7px] font-bold px-1 py-0.5 rounded-full leading-none whitespace-nowrap" data-testid="juegos-badge">
            {tab.badge}
          </span>
        )}
      </div>
      <span className={`text-[10px] font-medium transition-colors ${isActive ? 'text-[#fbb040]' : 'text-gray-400'}`}>
        {tab.label}
      </span>
    </button>
  );
}

export default function BottomNav({ active, onChange }) {
  const isHomeActive = active === 'inicio';

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 pb-[env(safe-area-inset-bottom)]"
      data-testid="bottom-nav"
    >
      {/* SVG notch background */}
      <div className="relative max-w-2xl mx-auto">
        {/* Notched bar shape */}
        <svg
          className="absolute bottom-0 left-0 right-0 w-full"
          viewBox="0 0 400 70"
          preserveAspectRatio="none"
          style={{ height: 70, filter: 'drop-shadow(0 -2px 4px rgba(0,0,0,0.04))' }}
        >
          <path
            d="M0,16 L152,16 C156,16 160,12 164,6 C170,-2 178,-2 186,-2 L214,-2 C222,-2 230,-2 236,6 C240,12 244,16 248,16 L400,16 L400,70 L0,70 Z"
            fill="white"
          />
        </svg>

        {/* Navigation content */}
        <div className="relative flex items-end justify-around h-[70px] px-2">
          {/* Left tabs */}
          <div className="flex items-end justify-center flex-1 pb-1">
            {SIDE_TABS_LEFT.map((tab) => (
              <SideTab key={tab.id} tab={tab} isActive={active === tab.id} onChange={onChange} />
            ))}
          </div>

          {/* Center FAB - K button */}
          <div className="flex flex-col items-center relative -top-5 mx-2">
            <motion.button
              whileTap={{ scale: 0.9 }}
              onClick={() => onChange('inicio')}
              className={`w-[60px] h-[60px] rounded-full flex items-center justify-center shadow-lg transition-shadow ${
                isHomeActive
                  ? 'bg-[#fbb040] shadow-[0_4px_20px_rgba(251,176,64,0.5)]'
                  : 'bg-[#fbb040] shadow-[0_4px_14px_rgba(251,176,64,0.35)] hover:shadow-[0_4px_20px_rgba(251,176,64,0.5)]'
              }`}
              data-testid="nav-tab-inicio"
            >
              <img
                src="/kompa-k-icon.png"
                alt="Inicio"
                className="w-8 h-8 object-contain"
                style={{ mixBlendMode: 'multiply' }}
                draggable={false}
              />
            </motion.button>
            <span className={`text-[10px] font-medium mt-0.5 transition-colors ${isHomeActive ? 'text-[#fbb040]' : 'text-gray-400'}`}>
              Inicio
            </span>
          </div>

          {/* Right tabs */}
          <div className="flex items-end justify-center flex-1 pb-1">
            {SIDE_TABS_RIGHT.map((tab) => (
              <SideTab key={tab.id} tab={tab} isActive={active === tab.id} onChange={onChange} />
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
